const baseURL = 
// "http://183.6.112.124:21100/gateway"
'/api/gateway'
; 

const photoURL =
//  "http://183.6.112.124:21200"
 '/minio'
 ;

export default {
  baseURL,
  photoURL,
};
